import { render, staticRenderFns } from "./user_total.vue?vue&type=template&id=8514eb18&"
import script from "./user_total.vue?vue&type=script&lang=ts&"
export * from "./user_total.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports